


















import { Component, Mixins, Prop } from 'vue-property-decorator'
import ModalBase from '@/components/common/molecules/ModalBase.vue'
import ModalBaseMethod from '@/mixins/ModalBaseMethod.vue'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'

@Component({
  components: {
    ModalBase,
    ButtonBase,
    InputSimple,
  },
})
export default class ModalUserAdd extends Mixins(ModalBaseMethod) {
  // タイトル表示文字列
  @Prop()
  title?: string

  private errorMessage = ''
  nickname = ''
  password = ''

  init() {
    this.errorMessage = ''
    this.nickname = ''
    this.password = ''
  }

  setErrorMessage(message: string) {
    this.errorMessage = message
  }

  private onClickOk() {
    if (this.validateNickname() && this.validatePassword()) this.$emit('click-ok')
  }

  private validateNickname() {
    if (this.nickname === '') {
      this.errorMessage = '氏名は必須項目です'
      return false
    }

    if (this.nickname.length > 20) {
      this.errorMessage = '氏名は20文字以内で入力してください'
      return false
    }

    return true
  }

  private validatePassword() {
    if (this.password === '') {
      this.errorMessage = 'パスワードは必須項目です'
      return false
    }

    if (this.password.length < 8) {
      this.errorMessage = 'パスワードは8文字以上で入力してください'
      return false
    }

    if (this.password.length > 12) {
      this.errorMessage = 'パスワードは12文字以内で入力してください'
      return false
    }

    if (!this.password.match(/^[A-Za-z0-9]+$/)) {
      this.errorMessage = 'パスワードは半角英数字のみ入力可能です'
      return false
    }

    return true
  }
}
